/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_SNAIL_FEAST = 47;

ManualStarters.SnailFeastStarter = function (type, options) {
    const location = cleverapps.meta.getSelectedLocation(); 

    if (location.isCompleted() || location.locationId !== Missions[type].location || !MissionTree.targets[type] || !MissionTree.targets[type].length) {
        return false;
    }

    let lastRemoved = cleverapps.missionManager.getLastRemoved(type);

    const locationMeta = cleverapps.meta.getLocationMeta(location.locationId);
    if (lastRemoved < locationMeta.getStartTime()) {
        lastRemoved = 0;
    }

    if (options && options.fromMissionTree) {
        return !lastRemoved;
    }

    if (!lastRemoved) {
        return false;
    }

    const duration = cleverapps.parseInterval(Missions[type].duration);
    let cooldown = Missions[type].cooldown && cleverapps.parseInterval(Missions[type].cooldown);
    if (cooldown && cleverapps.config.debugMode) {
        cooldown = cleverapps.parseInterval("3 minutes");
    }

    return locationMeta.getTimeLeft() >= duration && (!cooldown || lastRemoved + cooldown < Date.now());
};

Mission.REGISTRATIONS.set(Mission.TYPE_SNAIL_FEAST, () => ({
    name: "SnailFeast",
    view: SnailFeastWindow,
    startWindow: SnailFeastWindow,
    finishWindow: SnailFeastWindow,
    manualStart: ManualStarters.SnailFeastStarter,
    logic: FeastExpeditionLogic,
    duration: "6 hour",
    cooldown: "6 hour",
    bundle: () => `snail_feast_${cleverapps.skins.getSlot("skinName")}`,
    guideWindow: {
        name: "RaceGuideWindow.SnailFeast",
        title: "RaceGuideWindow.SnailFeast.title",
        bundle: bundles.snail_feast_guide_window
    },
    prize: RewardsConfig.SnailFeast.places,
    mainWorldReward: true,
    sideBarJson: function () {
        return cleverapps.skins.getSlot("snail_feast_icon_json") || bundles.sidebar.jsons.snail_feast_icon_json;
    },
    collectIcon: function () {
        return cleverapps.skins.getSlot("snail_feast_icon") || bundles.reward_icons.frames.snail_feast_icon;
    },
    sideBarSlotName: "expeditionFeastSideBarIcon",
    competition: {
        withScrollTable: false,
        step: [3, 3, 3, 3, 10, 10, 10, 65, 65],
        forceCoef: 0.45,
        amount: 5,
        noPlayerEpisodeCoef: true,
        botAheadPlayerCoef: 0.3,
        offlineCoef: 0.8,
        botAheadPlayerBigDifferenceCoef: 0.1,
        bigDistanceLength: 50
    }
}));
